import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import rootReducer from './reducers';
import { composeWithDevTools } from 'redux-devtools-extension';

const middleware = [thunk];
let applied = applyMiddleware(...middleware); // produccion
if (process.env.REACT_APP_MODO === 'development') {
  applied = composeWithDevTools(applyMiddleware(...middleware)); // desarrollo
}
export default createStore(rootReducer, applied);
